import React from 'react'
import css from './SegmentsComposition.less'

const dummySelections = {
    "buckets": [
        ["123","456","789"],
        ["234","567","890"]
    ]
};

const renderCompoition =
    (composition) =>
        composition.buckets.map(
            (orComp) =>
                orComp.map(
                    orEl => <div className='composition-el'>{orEl}</div>
                ).reduce((arr, el, idx) => {
                    arr.push(el);
                    if(idx < orComp.length -1){
                        arr.push(<span className='or-separator'>or</span>)
                    }
                    return arr;
                }, [])
        ).reduce((arr, el, idx) => {
            arr = arr.concat(el)
            if(idx < composition.buckets.length -1){
                arr.push(<div className='and-separator'>and</div>)
            }
            return arr;
        }, [])

const SegmentsComposition = (props) => {
    return (
    <div>
        <div>your selections</div>
        <div className='selections'>
            {renderCompoition(dummySelections)}
        </div>
    </div>
)};

export default SegmentsComposition;


// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/SegmentsComposition.js